moment = require('moment')

module.exports = (
  $scope,
  $upload,
  $uibModalInstance,
  Api,
  workflowStep,
  manualSource
) ->

  $scope.model =
    title: null
    snippet: null
    publishedDate: null

  $scope.create = () ->
    $scope.submitted = true
    if !$scope.forms.starredDocument.$valid
      return

    starredDocParams =
      workflow_step: workflowStep.id
      manual_source: manualSource
      title: $scope.model.title
      snippet: $scope.model.snippet
      relevance_type: 'red'
      source: 'text'

    publishedDate = moment($scope.model.publishedDate)
    if publishedDate.isValid()
      starredDocParams.published_date = publishedDate.format('YYYY-MM-DD')

    new Api.ProjectStarredDocument(starredDocParams).$save().then (starredDoc) ->
      $uibModalInstance.close starredDoc

  $scope.cancel = ->
    $uibModalInstance.close()
    return
